import http from "./httpService";
const apiUrl = require("../config.json").apiUrl;
// import  apiUrl  from ".././config.json";

export const getBoatHouse = () => {
  const apiEndPoint = `${apiUrl}/CheckddlBoatHouse`;
  return http.get(`${apiEndPoint}`);
};

export const getBoatType = (data) => {
  const apiEndPoint = `${apiUrl}/BHMstr/ddlBoatType`;
  return http.post(`${apiEndPoint}`, data);
};

// export const getAvailableBoatList = (data) => {
//   const apiEndPoint = `${apiUrl}/BoatBooking/BoatAvailableList`;
//   return http.post(`${apiEndPoint}`,data);
// };

export const getAvailableBoatList = (data) => {
  const apiEndPoint = `${apiUrl}/BoatAvailableList`;
  return http.post(`${apiEndPoint}`, data);
};

export const BlockBookingTimeSlot = (data) => {
  const apiEndPoint = `${apiUrl}/BlockBoatBookingTime`;
  return http.post(`${apiEndPoint}`, data);
};

export const getTimeSlot = (data) => {
  const apiEndPoint = `${apiUrl}/GetAvailableBoatSlotTime`;
  return http.post(`${apiEndPoint}`, data);
};

// export const getOtherServiceApi = () => {
//   const apiEndPoint = `${apiUrl}/ConfigMstr/ddlGroupName`;
//   return http.get(`${apiEndPoint}`);
// };

// export const ServiceListData=(data)=>{
//   const apiEndPoint = `${apiUrl}/OtherSvcCatDet`;
//   return http.post(`${apiEndPoint}`,data);
// }

export const OtherServiceListData = (data) => {
  const apiEndPoint = `${apiUrl}/PublicOtherServicesMstr/BHId`;
  return http.post(`${apiEndPoint}`, data);
};

export const getGstData = (data) => {
  const apiEndPoint = `${apiUrl}/TaxMstr/IdDate`;
  return http.post(`${apiEndPoint}`, data);
};

export const savePinTransation = (data) => {
  const apiEndPoint = `${apiUrl}/SavePinTransaction`;
  return http.post(`${apiEndPoint}`, data);
};

export const savePinTransation1 = (data) => {
  const apiEndPoint = `${apiUrl}/CommonAPIMethod`;
  return http.post(`${apiEndPoint}`, data);
};
export const bookingBeforeTransaction = (data) => {
  const apiEndPoint = `${apiUrl}/PublicOnlineBoatBookingBfrTran`;
  return http.post(`${apiEndPoint}`, data);
};

export const bookingAfterTransaction = (data) => {
  const apiEndPoint = `${apiUrl}/PublicOnlineBoatBookingAftrTran`;
  return http.post(`${apiEndPoint}`, data);
};

export const sendUPIsms = (data) => {
  const apiEndPoint = `${apiUrl}/SendSMSMsg`;
  return http.post(`${apiEndPoint}`, data);
};

export const getBoatHouseTiming = (data) => {
  const apiEndPoint = `${apiUrl}/GetBoatHouseTiming`;
  return http.post(`${apiEndPoint}`, data);
};

export const getTripFeedBack = (data) => {
  const apiEndPoint = `${apiUrl}/GetTripFeedBackComments`;
  return http.post(`${apiEndPoint}`, data);
};


export const getDefaultPaymentType = (data) => {
  const apiEndPoint = `${apiUrl}/CommonReport`;
  return http.post(`${apiEndPoint}`, data);
};
